<template>
  <div class="row">
    <div class="col">
      <p>Choose those Insurance Corporations (subsidaries/partners) you wish to relate with this location.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="input-group">
        <label class="input-group-text" for="insurance">Insurance Corporation:</label>
        <select v-model="firm2" id="insurance" class="form-control custom-select" @change="selected">
          <option v-for="item of availableInsurance" :key="item.firm" :value="item.firm">
            {{ item.firmName }}
          </option>
        </select>
        <button class="btn btn-success custom-focus" type="button" title="add" tabindex="-1" @click="add">
          <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>
    <div class="col"></div>
  </div>
  <div class="row">
    <div class="col-6">
      <ul class="custom-list">
        <li v-for="item in firmInsurance" :key="item.firmFirm">
          <div class="row">
            <div class="col">
              <span>{{ item.firmName }}</span>
            </div>
            <div class="col-1">
              <a href="#" class="custom-remove" @click="remove(item)">
                <i class="fas fa-times text-danger"></i>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'
export default {
  name: 'LocationInsurance',
  props: {
    firm: Object
  },
  data() {
    return {
      firm2: null
    }
  },
  computed: {
    ...mapState(locationStore, ['loading', 'firmInsurance', 'availableInsurance'])
  },
  methods: {
    ...mapActions(locationStore, ['getFirmInsurance', 'saveFirmInsurance', 'deleteFirmInsurance']),
    selected() {},
    async add() {
      if (this.firm2) {
        const firm = this.availableInsurance.find(
          (item) => parseInt(item.firm) === parseInt(this.firm.id) && parseInt(item.firm2) === parseInt(this.firm2)
        )
        if (firm === undefined || firm === null) {
          if (this.firm2 === this.firm.id) {
            return
          }
          let data = {
            firm: this.firm.id,
            firm2: this.firm2
          }
          await this.saveFirmInsurance(data)
          this.firm2 = null
          data = {
            firm: this.firm.id,
            type: 'firm'
          }
          await this.getFirmInsurance(data)
        }
      }
    },
    async remove(item) {
      await this.deleteFirmInsurance(item.firmFirm)
      let data = {
        firm: this.firm.id,
        type: 'firm'
      }
      await this.getFirmInsurance(data)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-select {
  width: 140px !important;
}
.custom-list {
  list-style-type: none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px;
  padding-left: 20px;
  margin-left: 5px;
  margin-right: 15px;
  height: 500px;
  li {
    border-bottom: 1px solid #eeeeee;
    padding: 5px;
  }
}
</style>
